/* minimize.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
            <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <rect y="7.5" class="foreground-gl" width="16" height="1"/>
            </svg>
         `,
};
